export function convertAddressFormat(address) {
    return {
        Street1: address.Company_Name || "",
        Street2: address.Address_2 || "",
        City: address.City || null,
        State: address.State || null,
        PostalCode: address.Postal_Code || null,
        Country: address.Country || ""
    };
}